import React, { useEffect, useState } from "react";
import apiClient from "../api/api";
import "../styles/EmployeeAttendance.css";

const OutsourceStatisticsPage = () => {
  const [statistics, setStatistics] = useState({
    today: 0,
    week: 0,
    month: 0,
  });

  const fetchAttendanceData = async () => {
    try {
      const response = await apiClient.get("/attendance");
      return response.data;
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      return [];
    }
  };

  const formatHours = (decimalHours) => {
    // Prevent negative values
    const safeHours = Math.max(0, decimalHours);
    const hours = Math.floor(safeHours);
    const minutes = Math.round((safeHours - hours) * 60);
    return `${hours}:${minutes.toString().padStart(2, "0")}`;
  };

  const calculateTotalHours = (start, end) => {
    if (!start || !end) return 0;
    try {
      const startTime = new Date(start);
      const endTime = new Date(end);
      if (isNaN(startTime.getTime()) || isNaN(endTime.getTime())) return 0;
      const diff = endTime - startTime;
      return diff / (1000 * 60 * 60);
    } catch (error) {
      console.error("Error calculating hours:", error);
      return 0;
    }
  };

  const isToday = (dateStr) => {
    const today = new Date().toISOString().split("T")[0];
    return dateStr === today;
  };

  const isCurrentWeek = (dateStr) => {
    const today = new Date();
    const checkDate = new Date(dateStr);
    const startOfWeek = new Date(today);
    const dayOfWeek = today.getDay();
    startOfWeek.setDate(today.getDate() - dayOfWeek + 1);
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    return checkDate >= startOfWeek && checkDate <= endOfWeek;
  };

  const isCurrentMonth = (dateStr) => {
    const today = new Date();
    const checkDate = new Date(dateStr);
    return (
      checkDate.getMonth() === today.getMonth() &&
      checkDate.getFullYear() === today.getFullYear()
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      const rawData = await fetchAttendanceData();

      let todayHours = 0;
      let weekHours = 0;
      let monthHours = 0;

      rawData.forEach(entry => {
        if (!entry.clock_in || !entry.clock_out) return;

        const hours = calculateTotalHours(entry.clock_in, entry.clock_out);

        if (isToday(entry.date)) {
          todayHours += hours;
        }
        if (isCurrentWeek(entry.date)) {
          weekHours += hours;
        }
        if (isCurrentMonth(entry.date)) {
          monthHours += hours;
        }
      });

      setStatistics({
        today: Math.max(0, Math.round(todayHours * 100) / 100),
        week: Math.max(0, Math.round(weekHours * 100) / 100),
        month: Math.max(0, Math.round(monthHours * 100) / 100),
      });
    };

    fetchData();
  }, []);

  const StatCard = ({ label, value, colorClass }) => {
    return (
      <div className="out-stat-card">
        <div className="out-stat-header">
          <span className="out-stat-label">{label}</span>
          <span className="out-stat-value">{value}</span>
        </div>
      </div>
    );
  };

  return (
    <div className="card statistics">
      <h2 className="card-title">Statistics</h2>
      <div className="out-statistics-grid">
        <StatCard
          label="Today"
          value={`${formatHours(statistics.today)}h`}
          colorClass="purple"
        />
        <StatCard
          label="This Week"
          value={`${formatHours(statistics.week)}h`}
          colorClass="blue"
        />
        <StatCard
          label="This Month"
          value={`${formatHours(statistics.month)}h`}
          colorClass="green"
        />
      </div>
    </div>
  );
};

export default OutsourceStatisticsPage;
